export const AdminLoading = () => (
  <div className="flex flex-col flex-1 gap-3">
    <div className="h-16 bg-white animate-pulse rounded-xl"></div>
    <div className="h-36 bg-white animate-pulse rounded-xl"></div>
    <div className="h-16 bg-white animate-pulse rounded-xl"></div>
    <div className="h-16 bg-white animate-pulse rounded-xl"></div>
  </div>
);
